module.exports = __webpack_public_path__ + "img/40_37_026_400.cb0266b7.jpg";